/**
 *  * On create custom event, avoid these reserved event names:
 * @link https://knowandconnect.com/ga4-event-naming-rules/
 */
export const GA_EVENTS = {
  SELECT: 'select_item',
  SEARCH: 'search',
  EDIT: 'edit',
  CREATE: 'create',
  DELETE: 'delete',
  BUTTON_CLICK: 'button_click',
}

const truncate = (value, limit = 60) => {
  if(!value) return 'label_not_specified'
  if (typeof value !== 'string') return value;

  return value
    .trim()   
    .replace(/\s+/g, '_')
    .substring(0, limit)
}

/**
 * This util function return the event based on `GA_EVENTS`\
 * If the label props is not setted on params, the value will be `label_not_specified`
 * 
 * 
 * @param {object} props
 * @param {string} props.eventType 
 * @param {string} props.label 
 * 
 * @typedef GAEvent
 * @property {string} action
 * @property {Record<string, string>} properties 
 *  
 * @returns {GAEvent} Event
 */
export const getGAEvent = ({eventType, label}) => {
  const events = {
    [GA_EVENTS.SELECT]: {
      action: GA_EVENTS.SELECT,
      properties: {
        event_category: 'selection',
        event_label: truncate(label)
      }
    },
    [GA_EVENTS.SEARCH]: {
      action: GA_EVENTS.SEARCH,
      properties: {
        event_category: 'engagement',
        search_term: truncate(label),
      }
    },
    [GA_EVENTS.EDIT]: {
      action: GA_EVENTS.EDIT,
      properties: {
        event_category: 'management',
        event_label: truncate(label),
      }
    },
    [GA_EVENTS.CREATE]: {
      action: GA_EVENTS.CREATE,
      properties: {
        event_category: 'management',
        event_label: truncate(label),
      }
    },
    [GA_EVENTS.DELETE]: {
      action: GA_EVENTS.DELETE,
      properties: {
        event_category: 'management',
        event_label: truncate(label),
      }
    },
    [GA_EVENTS.BUTTON_CLICK]: {
      action: GA_EVENTS.BUTTON_CLICK,
      properties: {
        event_category: 'interaction',
        event_label: truncate(label),
      }
    }
  }

  return events[eventType] || null
}
